import { ProductSlider } from '@/components/ProductSlider';
import type { Watch } from '@/views/MyWatchesView/MyWatchesView';

import { MyWatchCard } from '../../../MyWatchCard';

import * as S from './MyWatchesSlider.styles';

export interface WatchesSliderProps {
  watches: Watch[];
}

export const MyWatchesSlider = ({ watches }: WatchesSliderProps) => {
  return (
    <S.InnerWrapper data-test-id='MyWatchesSliderInnerWrapper'>
      <ProductSlider data-test-id='MyWatchesSlider'>
        <ProductSlider.Slider
          data-test-id='MyWatchesSliderSlider'
          slidesPerView={1}
          slidesPerViewForMobile='auto'
          spaceBetween={16}
        >
          {watches.map((watch, index) => (
            <MyWatchCard
              key={watch.id}
              data-test-id={`MyWatchesSliderCard-${index}`}
              watch={watch}
            />
          ))}
        </ProductSlider.Slider>
      </ProductSlider>
    </S.InnerWrapper>
  );
};

MyWatchesSlider.displayName = 'MyWatchesSlider';
